import { StatusCarte } from '@/enum/StatusCarte';
import Vue from 'vue'

export const statusAbo = (value: number) => {    
    switch(value){
        case StatusCarte.valide: return "Valide"
        case StatusCarte.complet: return "Complet semaine"
        case StatusCarte.perime: return "Périmé"
    } 
    return "";    
}
Vue.filter('statusAbo', statusAbo)